import {
  ZONES_BY_HEADER,
  PRODUCT_OFFERING_TYPES,
  TIPOS_R2R,
} from '@/utils/constants';

export const normalizeUserBundleExtraInfo = (mainInfo) => {
  const {
    userBundle,
    userPo,
  } = mainInfo || {};

  const clientInfo = {
    bundleModules: [],
    productZoneId: ZONES_BY_HEADER.FREE,
  };

  let userBundleProducts = [];
  if (userBundle && typeof userBundle === 'object') {
    userBundleProducts = Object.values(userBundle);
  }

  userBundleProducts.forEach((userBundleProduct) => {
    const {
      mainZone,
      pot,
    } = userBundleProduct || {};

    const potArr = Array.isArray(pot) ? pot : [];

    if (potArr.some(
      (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID,
    )) {
      clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.MIMOVISTAR.ID;
      clientInfo.bundleModules = userPo?.PACK_MODULES?.split('||').map((part) => part.replace(/---/g, '').trim()).filter(Boolean) || [];
      if (mainZone) {
        clientInfo.productZoneId = mainZone;
      }
    }
    if (!clientInfo.productType) {
      // si no tengo info todavia la relleno
      // y solo si es del type que busco relleno el productType
      if (potArr.some(
        (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.FUSION.ID,
      )) {
        clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.FUSION.ID;
      } else if (potArr.some(
        (element) => element.id === PRODUCT_OFFERING_TYPES.PRODUCTS.BAF.ID,
      )) {
        clientInfo.productType = PRODUCT_OFFERING_TYPES.PRODUCTS.BAF.ID;
      }
    }
  });

  return clientInfo;
}

export const getR2rTypeByApi = (clt) => {
  let result = null;
  if (clt === 4 || clt === 6 || !clt) {
    result = TIPOS_R2R.INCLUIDO;
  } else if (clt === 5) {
    result = TIPOS_R2R.ADICIONAL;
  } else {
    result = TIPOS_R2R.NO_DISPONIBLE;
  }
  return result;
}
